import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function formatHeaderDate() {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export default function Header() {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleDashboardClick = (e) => {
    e.preventDefault();
    navigate("/dashboard/");
  };

  return (
    <header className="main_header_area">
      <div className="header-content py-1 bg-theme">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="links">
            <ul>
              <li>
                <a href="#" className="white">
                  <i className="icon-calendar white" /> {formatHeaderDate()}
                </a>
              </li>
              <li>
                <a href="#" className="white">
                  <i className="icon-location-pin white" /> 254 Goldhawk Road, London, England, W12 9PE
                </a>
              </li>
              <li>
                <a href="#" className="white">
                  <i className="icon-clock white" /> Mon-Fri: 10 AM – 5 PM
                </a>
              </li>
            </ul>
          </div>
          {isAuthenticated() ? (
            <div className="links float-right">
              <ul>
                <li>
                  <a href="#" className="white">
                    {user?.first_name} {user?.last_name}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="white"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLogout();
                    }}
                  >
                    <span className="link-title">Logout</span>
                  </a>
                </li>
              </ul>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* Navigation Bar */}
      <div className="header_menu" id="header_menu">
        <nav className="navbar navbar-default">
          <div className="container">
            <div className="navbar-flex d-flex align-items-center justify-content-between w-100 pb-3 pt-3">
              {/* Brand and toggle get grouped for better mobile display */}
              <div className="navbar-header">
                <Link className="navbar-brand" to="/">
                  <img src="/images/logo.png" alt="image" width={180} />
                </Link>
              </div>
              {/* Collect the nav links, forms, and other content for toggling */}
              <div
                className="navbar-collapse1 d-flex align-items-center"
                id="bs-example-navbar-collapse-1"
              >
                <ul className="nav navbar-nav nav-main-links" id="responsive-menu">
                  <li className="">
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
              {/* /.navbar-collapse */}
              <div className="register-login d-flex align-items-center">
                {isAuthenticated() ? (
                  <a
                    href="#"
                    onClick={handleDashboardClick}
                    className="nir-btn white"
                  >
                    Dashboard
                  </a>
                ) : (
                  <a
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    className="nir-btn white"
                  >
                    Login
                  </a>
                )}
              </div>
              <div id="slicknav-mobile" />
            </div>
          </div>
          {/* /.container-fluid */}
        </nav>
      </div>
      {/* Navigation Bar Ends */}
    </header>
  );
}
